import data from "../../../../../src/Details/Details.docs.json";
import * as React from 'react';
export default {
  data,
  React
};